function SvgStar(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 91 88" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M2.898 39.648l17.609 12.793a5.74 5.74 0 012.088 6.416l-6.73 20.705c-1.717 5.289 4.336 9.688 8.838 6.42l17.609-12.795a5.733 5.733 0 016.746 0l17.609 12.795c4.5 3.268 10.555-1.131 8.838-6.42l-6.727-20.705a5.73 5.73 0 012.086-6.416l17.607-12.793c4.498-3.27 2.189-10.387-3.373-10.387H63.332a5.742 5.742 0 01-5.461-3.967L51.146 4.596c-1.719-5.293-9.201-5.293-10.922 0l-6.729 20.699a5.733 5.733 0 01-5.457 3.967H6.271c-5.562 0-7.871 7.117-3.373 10.386z" />
    </svg>
  );
}

export default SvgStar;
